import bus from '~/bus'
import { getEventFile } from '~/helpers/eventHelper'
export default {
  name: 'starred',
  do: function (payload) {
    console.log('DEBUG starred: ', this, payload)
    if (this.file === 'starred') {
      if (payload.starred) {
        bus.$emit('doBackgroundReload', 'starred')
      } else {
        bus.$emit('deleteFile', payload.deprecated_file_id)
      }
    }
    if (this.fileChildren && this.fileChildren.includes(payload.file_id)) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/starred.js